import * as React from "react";
import { PageTemplate } from "~/pages/_pageTemplate";
import "./404.scss";
import { HeadTag } from "~/pages/_headTag";
import Text404 from "~/assets/text_404.svg";

export const Head = () => <HeadTag pageTitle="404 Not Found." noIndex={true} />

export default () => {
    return (
        <PageTemplate >
            <section className="common_section notFound">
            <h2 className="common_h2 notFound__head"><Text404 /></h2>
            <div className="common_section__content common_section__content--bg_transparent notFound__body">
                We couldn't find the page you were requested.<br/>
                But the clothing you're looking for is surely somewhere in the world.<br/>
                Let's explore for it with us!
            </div>
        </section>
        </PageTemplate>
    )
}
